import React from 'react';

import "./style.css"
import { Select, Spin, Icon, message, Modal } from 'antd';
import EventSet from "./../../../assets/PubJs/hcPub"
import "./../../../assets/PubJs/Bcharts"
import { Hcurl } from "./../../../constants/index"//获取公共路径
import notice from "./../../../assets/images/TZ.svg"//图片
import $ from "jquery"

const Option = Select.Option;

var base = new EventSet.Base64();
//公告部分标题
let _NoticeTitle = null;
class NoticeTitle extends React.Component {

    state = {
        year: "最新",
        yearData: []
    };

    //年份改变
    handleChangeYear(value) {
        this.setState({
            year: value
        });
        _App.getNoticeList(encodeURI(value))
    }

    //组件完成
    componentDidMount() {
        _NoticeTitle = this;
        $.ajax({
            url: Hcurl + "/HomePage/GetpublicYears",
            type: "get",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            async: false,
            success: function (res) {
                _NoticeTitle.setState({
                    yearData: res == null ? [] : res
                })

            },
            error: function (data, err) {
                //console.log(data, err)
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                } else {
                    message.error(err)
                }
            }
        })
    }

    render() {
        return (

            <div className="C_topTitle clear">
                <img style={{ width: "18px", position: "relative", top: "7.5px", marginRight: "6px" }} className="left" src={notice} alt="" />
                <span className="left">公告</span>
                <div className="right" style={{ marginLeft: "20px" }}>
                    <span>年份&nbsp;:&nbsp;&nbsp;</span>
                    <Select size={"default"} value={this.state.year} className="right" style={{ width: 120 }}
                        onChange={this.handleChangeYear.bind(this)}>
                        <Option value="最新">最新</Option>
                        {
                            this.state.yearData.map(function (e) {
                                return <Option key={e.Year} value={e.Year}>{e.Year}</Option>
                            })
                        }
                    </Select>
                </div>
            </div>
        )
    }

}

//公告弹窗
let _NoticeModal = null;

class NoticeModal extends React.Component {
    state = {
        visible: false,
        text: {
            ID: "",
            JoinDate: "",
            U_UserName: "",
            Pub_Title: "",
            Pub_Attachs: "",
        }
    }

    //弹出modal
    showModal = (e) => {
        this.setState({
            visible: true,
            text: e
        });
        setTimeout(()=> {
            $('.ant-modal-header').addClass("header_style")
            $('.ant-modal-body').addClass("body_style")
            //console.log(((e.Pub_Content)))
            var base = new EventSet.Base64();
            try { $('#NoticeCon').html(decodeURIComponent(base.decode(e.Pub_Content)))} catch(e){}
        }, 30);
        //console.log(e)
    };

    //关闭弹框
    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
        $('.ant-modal-header').removeClass("header_style")
        $('.ant-modal-body').removeClass("body_style")
    };

    componentDidMount() {
        _NoticeModal = this;
    }

    render() {
        const title = <div id={"NoticeModal"}>
            <div style={{ fontSize: "26px", paddingRight: "12px", lineHeight: "32px" }}>{this.state.text.Pub_Title}</div>
            <p style={{
                fontSize: "14px",
                paddingRight: "12px",
                marginTop: "8px",
                marginBottom: 0,
                color: "rgba(0,0,0,.55)"
            }}>
                <Icon type="clock-circle-o" />
                <span style={{ margin: "0 8px" }}>{this.state.text.JoinDate}</span>
                <Icon type="user" />
                <span style={{ margin: "0 8px" }}>{this.state.text.Dept_Name}({this.state.text.U_UserName})</span>
            </p>
        </div>;
        return (
            <div>
                <Modal

                    title={title}
                    visible={this.state.visible}
                    width={860}
                    footer={null}
                    onCancel={this.handleCancel}
                >
                    <div>
                        {
                            this.state.text.Pub_Attachs.split(";").length === 1 ? "" : <p style={{ marginBottom: "0px", borderBottom: "1px solid #e9e9e9", padding: "16px" }}>
                                <span style={{ margin: "0 8px" }}>附件： </span>
                                <span>
                                    {
                                        this.state.text.Pub_Attachs.split(";").map(function (e, index) {
                                            return <a key={index} href={e} style={{ marginRight: "16px", display: e.toString() === "" ? "none" : "inline-block" }} target='_blank'><Icon type="link" />附件{index + 1}</a>
                                        })
                                    }

                                </span>
                            </p>
                        }

                        <div id={"NoticeCon"} style={{ padding: "16px", minHeight: "320px", maxHeight: "480px", overflowY: "auto" }}>
                        </div>
                    </div>

                </Modal>
            </div>
        );
    }
}

let _App = null;

class App extends React.Component {
    state = {
        wid: 0,
        listData: []
    }

    componentWillMount() {
        _App = this;
    }

    //获取公共列表
    getNoticeList(e) {
        $.ajax({
            url: Hcurl + "/HomePage/GetPublicInfoList?Type=" + e,
            type: "get",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            async: false,
            success: function (res) {
                _App.setState({
                    listData: res
                })
            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                } else {
                    message.error(err)
                }
            }
        })
    }

    //组件完成
    componentDidMount() {
        this.getNoticeList(encodeURI("最新"))
    }

    render() {
        return (
            <div className="C_content">
                <NoticeTitle />
                <NoticeModal />
                <div className="C_content_son">
                    <div className={"lawcon"} style={{ height: this.props.hei - 70 }}>
                        {
                            this.state.listData.map(function (e) {
                                return <div onClick={() => _NoticeModal.showModal(e)} key={e.ID}
                                    className={"lawList"} title={e.Pub_Title}>
                                    <span className={"con"}>{e.Pub_Title}</span>
                                    <Icon
                                        type="link"
                                        style={{
                                            position: "relative",
                                            top: "-5px",
                                            marginLeft: "10px",
                                            color: "#038374",
                                            fontSize: "18px",
                                            display: (e.Pub_Attachs === "" || e.Pub_Attachs === null) ? "none" : "inline-block"
                                        }}
                                    />
                                    <span className={"time"}>{e.JoinDate}</span>
                                </div>
                            })
                        }

                    </div>
                </div>
            </div>
        )
    }
}

export default App


// WEBPACK FOOTER //
// ./src/components/Content/Home/Notice.js